import { render, staticRenderFns } from "./RoleComponent.vue?vue&type=template&id=775e8b3d&"
import script from "./RoleComponent.vue?vue&type=script&lang=js&"
export * from "./RoleComponent.vue?vue&type=script&lang=js&"
import style0 from "./RoleComponent.vue?vue&type=style&index=0&id=775e8b3d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports